import { onBeforeUnmount, onMounted } from "vue";

export default function useDetectOutsideClick(component, callback) {
  if (!component) return;
  const listener = (event) => {
    const datePickerPanels = document.querySelectorAll(".el-picker-panel");
    const isClickInsideDatePicker = Array.from(datePickerPanels).some((panel) =>
      panel.contains(event.target)
    );

    if (
      !event.target !== component.value &&
      !event.composedPath().includes(component.value) &&
      !isClickInsideDatePicker
    ) {
      callback();
    }
  };
  onMounted(() => {
    window.addEventListener("click", listener);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("click", listener);
  });

  return { listener };
}
